import { useQuery, useQueryClient } from '@tanstack/react-query'
import { legalService } from '@/lib/services/legal.service'

export const rentalTermsKey = ['legal', 'rental-terms', 'current'] as const

export function useCurrentRentalTerms() {
  return useQuery({
    queryKey: rentalTermsKey,
    queryFn: () => legalService.currentRentalTerms(),
    staleTime: 0,
    refetchOnMount: 'always',
  })
}

export function useRefreshRentalTerms() {
  const client = useQueryClient()
  return () => client.invalidateQueries({ queryKey: rentalTermsKey })
}
